import {Gear} from 'data/records'
import {resource, collection, findSelector} from 'data/helpers/apiv3'

const [api, actions] = resource(Gear, [
  ['list', collection.get('', ['userId'])]
])

const selectors = {
  ...findSelector(Gear),
  byUserId: (state, userId) => state.apiv3.gear.id.filter(g => g.userId === userId)
}

const reducers = {}

const initialState = {}

export {
  api as gearApi,
  actions as gearActions,
  selectors as gearSelectors,
  reducers as gearReducers,
  initialState as gearInitialState
}
